import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', function (date, lang) {
  if (date.length > 0) {
    moment.locale(lang.lang)
    if (lang.dateFormat && lang.dateFormat.length > 0) {
      return moment(date).format(lang.dateFormat)
    } else {
      return moment(date).format('L')
    }
  } else {
    return ''
  }
})
Vue.filter('formatTime', function (time, lang) {
  if (time != null && time.length > 0) {
    return moment(time, 'HH:mm').format(lang.timeFormat)
  } else {
    return ''
  }
})
Vue.filter('formatTimeFromSec', function (time) {
  if (time != null) {
    var minutes = Math.floor(time / 60)
    var seconds = time - minutes * 60
    var minuteString = minutes < 10 ? '0' + minutes : minutes
    var secondString = seconds < 10 ? '0' + seconds : seconds
    return minuteString + ':' + secondString
  } else {
    return ''
  }
})
